import React from 'react';
// Removed LandingNav import
import '../LandingPage/LandingPage.css'; // Keep for CSS variables potentially
import './TermsConditionsPage.css'; 

// We might need to add specific styles for this page later
// import './TermsConditionsPage.css'; 

export default function TermsConditionsPage() {
  return (
    // Use a specific class for this page instead of landing-page to avoid nav padding
    <div className="terms-page"> 
      {/* Removed header div */}
      
      <div className="terms-content-container"> 
        {/* Moved SVG logo here */}
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="terms-logo">
          <path d="M15.578 9.01277C14.7616 8.19637 13.4808 8.03231 12.5632 8.73312C10.9429 9.97072 9.527 11.4624 8.37501 13.1487C7.74895 14.0651 7.93561 15.2837 8.72039 16.0685L15.4952 22.8433C16.227 23.5751 16.227 24.7614 15.4952 25.4932L8.95765 32.0308C8.15835 32.8301 7.98173 34.0772 8.6419 34.9948C9.83323 36.6506 11.2838 38.1075 12.9341 39.3059C13.8518 39.9723 15.1041 39.7976 15.9061 38.9957L20.7339 34.1679C21.7823 33.1194 22.3713 31.6974 22.3713 30.2147V18.1218C22.3713 16.6391 21.7823 15.2171 20.7339 14.1686L15.578 9.01277Z" fill="var(--text-primary)"/>
          <path d="M38.9815 32.4231C39.798 33.2397 39.962 34.5208 39.2607 35.4384C38.0227 37.0583 36.5306 38.4738 34.8439 39.6253C33.9275 40.251 32.7093 40.0642 31.9247 39.2796L26.8132 34.1682C25.7648 33.1198 25.1758 31.6978 25.1758 30.215V18.1221C25.1758 16.6394 25.7648 15.2174 26.8132 14.1689L32.2616 8.72062C33.0607 7.92148 34.3075 7.74475 35.2251 8.40454C36.8813 9.59545 38.3385 11.0456 39.5374 12.6957C40.2042 13.6133 40.0295 14.866 39.2274 15.668L32.0518 22.8436C31.3201 23.5754 31.3201 24.7618 32.0518 25.4935L38.9815 32.4231Z" fill="var(--text-primary)"/>
        </svg>
        <h1>Terms & Conditions</h1>
        <div> 
          <p>
            Welcome to Texta, a translation management and collaboration tool developed by Designers Stash. By accessing or using our app, you agree to be bound by these Terms and Conditions. Please read them carefully.
          </p>

          <h2>Services</h2>
          <p>
            Texta provides comprehensive translation management and collaboration services. Users can manage translation projects, collaborate with team members, and ensure efficient workflow. Additionally, Texta offers AI-powered translation services using advanced models for automated translations.
          </p>

          <h2>User Data and Privacy</h2>
          <h3>1. Ownership of Data:</h3>
          <p>
            All data submitted by users, including text inputs, translated outputs, project details, and collaboration activities, remains the sole property of the user. We do not claim any ownership rights over the content you provide.
          </p>
          <h3>2. Data Usage:</h3>
          <p>
            We do not use your data to train any AI models or for any purpose other than providing the translation and collaboration services you request.
          </p>
          <h3>3. Privacy:</h3>
          <p>
            We are committed to protecting your privacy. We will not share your data with third parties without your explicit consent, except as required by law.
          </p>

          <h2>User Responsibilities</h2>
          <h3>1. Accurate Information:</h3>
          <p>
            You agree to provide accurate and complete information when using our services.
          </p>
          <h3>2. Lawful Use:</h3>
          <p>
            You agree to use our services only for lawful purposes and in a manner that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the service.
          </p>
          <h3>3. Prohibited Content:</h3>
          <p>
            You must not submit any content that is illegal, offensive, or violates any third-party rights.
          </p>

          {/* ... (rest of the content omitted, basic HTML structure) ... */}
          {/* Added missing sections for completeness */}
          <h2>Collaboration and Project Management</h2>
          <h3>1. Project Creation:</h3>
          <p>
            Users can create and manage translation projects within Texta. This includes assigning tasks, setting deadlines, and tracking progress.
          </p>
          <h3>2. Team Collaboration:</h3>
          <p>
            Texta allows multiple users to collaborate on translation projects. Users can share files, communicate, and provide feedback within the app.
          </p>
          <h3>3. User Roles:</h3>
          <p>
            Project owners can assign different roles to team members, such as translators, reviewers, and project managers.
          </p>

          <h2>AI-Powered Translation Services</h2>
          <h3>1. Service Provision:</h3>
          <p>
            Texta offers AI-powered translation services as an optional feature to assist with automated translations.
          </p>
          <h3>2. Accuracy of Translations:</h3>
          <p>
            While we strive to provide accurate translations using AI, we do not guarantee the accuracy, completeness, or reliability of any translated text.
          </p>

          <h2>Intellectual Property</h2>
          <h3>1. Service Ownership:</h3>
          <p>
            All intellectual property rights in the app and services are owned by Designers Stash. This includes but is not limited to software, algorithms, and interface design.
          </p>
          <h3>2. User Content:</h3>
          <p>
            While you retain ownership of the data you provide, you grant Designers Stash a non-exclusive, royalty-free license to use your data solely for the purpose of providing the translation and collaboration services.
          </p>

          <h2>Disclaimer of Warranties</h2>
          <h3>1. Service "As Is":</h3>
          <p>
            The translation and collaboration services are provided on an "as is" and "as available" basis. We do not guarantee that the service will be uninterrupted, error-free, or meet your specific requirements.
          </p>
          <h3>2. AI Translation Accuracy:</h3>
          <p>
            While we strive to provide accurate translations, we do not guarantee the accuracy, completeness, or reliability of any AI-generated translated text.
          </p>

          <h2>Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Designers Stash shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from:
          </p>
          <ol>
            <li>Your use or inability to use the service.</li>
            <li>Any unauthorized access to or use of our servers and/or any personal information stored therein.</li>
          </ol>

          <h2>Changes to Terms and Conditions</h2>
          <p>
            We may revise these Terms and Conditions from time to time. The most current version will always be available on our app. By continuing to access or use the services after any changes become effective, you agree to be bound by the revised terms.
          </p>
        </div>
      </div>
    </div>
  );
} 